<template>
	<div class="go-btn-box">
		<van-button class="go-back" icon="arrow-left" @click='goBackPage' />
		<van-button class="go-next" icon="arrow" @click='goNextPage' />
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Button
	} from 'vant';

	Vue.use(Button);

	export default {
		name: 'bottomTab',
		methods: {
			goBackPage() {
				this.$router.go(-1)
			},
			goNextPage(){
				history.forward()
			}
		}
	}
</script>

<style scoped>
	.go-btn-box {
		position: fixed;
		bottom: -1px;
		height: 44px;
		left: 0;
		right: 0;
	}

	.go-back,
	.go-next {
		width: 50%;
		border: none;
		border-top: 1px solid rgb(241, 241, 241);
		position: absolute;
		top: 0;
	}
	.go-back{
		left: 0;
	}
	.go-next{
		right: 0;
	}
</style>
